export enum ChatbotChannel {
  LINE = 'LINE',
  WECHAT = 'WECHAT',
  WHATS_APP = 'WHATS_APP',
  RESPOND_IO = 'RESPOND_IO',
}

export class ChatbotGuestSignInBody {
  customerName: string;
  customerPhone: string;
  partnerId: number;
  nationalityNo?: string;
  chatbotChannel?: ChatbotChannel;
  userKey?: string;
  birth?: string;
  gender?: 'MALE' | 'FEMALE';
}
